document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname;
  const sliderLinks = document.querySelectorAll('.instant-slider-slide');
  
  sliderLinks.forEach(link => {
    if (link.getAttribute('href') === currentPath) {
      const textElement = link.querySelector('p');
      if (textElement) {
        textElement.style.fontWeight = '800';
      }
    }
  });
});
